import { useMemo } from 'react';

const GUEST_OPTIONS_OTHER_VALUE = -1;
const GUEST_OPTIONS_CURRENT_USER_VALUE = -2;

export const useGuestOptions = ({ guests, currentUser }) =>
  useMemo(
    () => [
      {
        firstname: currentUser.firstname,
        lastname: currentUser.lastname,
        email: currentUser.email,
        company_name: currentUser.company_name,
        mobile_phone: currentUser.mobile_perso,
        label: `${currentUser.firstname} ${currentUser.lastname}`,
        value: GUEST_OPTIONS_CURRENT_USER_VALUE,
      },
      ...(guests || []).map((guest) => ({
        ...guest,
        value: guest.guest_id,
        label: `${guest.firstname} ${guest.lastname}`,
      })),
      {
        label: __('Add an external guest'),
        value: GUEST_OPTIONS_OTHER_VALUE,
      },
    ],
    [guests],
  );

export { GUEST_OPTIONS_CURRENT_USER_VALUE, GUEST_OPTIONS_OTHER_VALUE };
